import React, { useEffect, useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { isEmptyObject } from '../../../../utils';
import { AuthenticatedGETRequest, AuthenticatedPUTRequest } from '../../../../utils';
export const leavingIntituteRessons = ['مزید تعلیم', 'کوئی نہیں'];
export const hostilites = ['اقامتی', 'غیراقامتی'];

const EducationDetails = (props) => {
    const { data, isStudent, setState, onError, onClose } = props;
    const [loading, setLoading] = useState(false);
    const [classes, setClasses] = useState([]);
    const [JamiaClassesList, setList] = useState([]);
    const [educationInformation, setEducationInformation] = useState(data);
    let [jamiaDepartments, setDepartments] = useState([]);

    const getCurrentYear = () => new Date().getFullYear();
    useEffect(() => {
        if (classes && classes.length > 0) {
            let urdu_degree_list = (list) => {
                let unique_values = list
                    .map((item) => item.name)
                    .filter(
                        (value, index, current_value) => current_value.indexOf(value) === index,
                    );
                return unique_values;
            };
            let departments_list = (list) => {
                let unique_values = list
                    .map((item) => item.department_urdu_name)
                    .filter(
                        (value, index, current_value) => current_value.indexOf(value) === index,
                    );
                return unique_values;
            };
            setDepartments(departments_list(classes));
            setList(urdu_degree_list(classes));
        }
    }, [classes]);

    const getDepartmnentEnglishName = (urdu_name) => {
        let department = classes.find((item) => item.department_urdu_name === urdu_name);
        return department.department_english_name;
    };

    const getClassroomEnglishName = (id) => {
        let classroom = classes.find((item) => item.id === id);
        return classroom.english_name;
    };

    const onSubmit = async (id, updatedInformation) => {
        const { data, success } = await AuthenticatedPUTRequest(
            isStudent ? `students/${id}` : `applicants/${id}`,
            updatedInformation,
        );
        setLoading(false);
        onClose();
        if (!success) {
            onError('براہ کرم دوبارہ کوشش کریں۔');
        } else {
            setState(data);
        }
    };

    const onUpdate = () => {
        setLoading(true);
        var updatedInformation = {};
        for (let key in educationInformation) {
            if (key !== 'branch' && key !== 'class_room') {
                if (educationInformation[key] !== data[key]) {
                    updatedInformation[key] = educationInformation[key];
                }
            }
        }
        if (!isEmptyObject(updatedInformation)) {
            onSubmit(educationInformation.id, updatedInformation);
        } else {
            setLoading(false);
            onClose();
        }
    };

    useEffect(() => {
        const fetchClasses = async () => {
            try {
                const { data } = await AuthenticatedGETRequest('class_rooms');
                setClasses(data);
            } catch (error) {
                onError(`Error fetching error=${JSON.stringify(error)}`);
            }
        };
        fetchClasses();
    }, [onError]);

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 650,
                    maxHeight: 650,
                    width: 980,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            تعلیم سے متعلق معلومات ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20 }}
                    >
                        <div className='flex column w-100'>
                            {/* current_religious_education */}
                            <div className='flex justifyBetween alignCenter'>
                                <div className='form-container urdu'>
                                    <label htmlFor='current_religious_education'>
                                        موجودہ ​​دینی تعلیم
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='current_religious_education'
                                        defaultValue={
                                            educationInformation['current_religious_education']
                                        }
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    current_religious_education: e.target.value,
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    current_religious_education:
                                                        JamiaClassesList.length > 0
                                                            ? JamiaClassesList[0]
                                                            : '',
                                                });
                                            }
                                        }}
                                    >
                                        {JamiaClassesList.map((name, index) => (
                                            <option value={name} key={index + 1}>
                                                {name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* current_modern_education */}
                                <div className='form-container urdu'>
                                    <label htmlFor='current_modern_education'>
                                        موجودہ ​​عصری تعلیم
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='current_modern_education'
                                        value={educationInformation['current_modern_education']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    current_modern_education: e.target.value,
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    current_modern_education: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className='flex justifyBetween alignCenter'>
                                {/* former_religious_education_institute */}
                                <div className='form-container urdu'>
                                    <label htmlFor='former_religious_education_institute'>
                                        سابقہ دینی ​​تعلیمی ادارہ
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='former_religious_education_institute'
                                        value={
                                            educationInformation[
                                                'former_religious_education_institute'
                                            ]
                                        }
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    former_religious_education_institute:
                                                        e.target.value,
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    former_religious_education_institute: '',
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* reason_for_leaving_former_religious_institute */}
                                <div className='form-container urdu'>
                                    <label htmlFor='reason_for_leaving_former_religious_institute'>
                                        سابقہ ​​تعلیمی مرکز چھوڑنے کی وجہ
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='reason_for_leaving_former_religious_institute'
                                        defaultValue={
                                            educationInformation[
                                                'reason_for_leaving_former_religious_institute'
                                            ]
                                        }
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    reason_for_leaving_former_religious_institute:
                                                        e.target.value,
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    reason_for_leaving_former_religious_institute:
                                                        '',
                                                });
                                            }
                                        }}
                                    >
                                        {leavingIntituteRessons.map((reason, index) => (
                                            <option
                                                value={reason}
                                                key={index + 1}
                                                defaultValue={
                                                    reason ===
                                                    educationInformation[
                                                        'reason_for_leaving_former_religious_institute'
                                                    ]
                                                }
                                            >
                                                {reason}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Section head */}
                            <h6 className='description mt-64-mb-24'>
                                کلاس کی معلومات (موجودہ تعلیمی سال
                                <span className='redText mlr'>{getCurrentYear()}</span>
                                کی معلومات درج کریں)
                                <span className='redText mlr'>*</span>
                            </h6>

                            <div className='flex justifyBetween alignCenter'>
                                {/* degrees list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='department'>
                                        شعبہ منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='department'
                                        value={educationInformation['department']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    department: e.target.value,
                                                    department_for_card: getDepartmnentEnglishName(
                                                        e.target.value,
                                                    ),
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    department: educationInformation['department'],
                                                    department_for_card:
                                                        educationInformation['department_for_card'],
                                                });
                                            }
                                        }}
                                    >
                                        <option value='none'>اپنا شعبہ منتخب کریں</option>
                                        {jamiaDepartments.map((degree, index) => (
                                            <option value={degree} key={index + 1}>
                                                {degree}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* classes list */}
                                <div className='form-container urdu'>
                                    <label htmlFor='class_name'>
                                        درجہ منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='class_name'
                                        value={educationInformation['class_room']['id']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    class_room_id: e.target.value,
                                                    section_for_card: getClassroomEnglishName(
                                                        e.target.value,
                                                    ),
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    class_room_id:
                                                        educationInformation['class_room_id'],
                                                    section_for_card:
                                                        educationInformation['section_for_card'],
                                                });
                                            }
                                        }}
                                    >
                                        <option value='none'>اپنا درجہ منتخب کریں</option>
                                        {classes.map((item, idx) => (
                                            <option value={item.id} key={idx + 1}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {/* residency */}
                                <div className='form-container urdu'>
                                    <label htmlFor='residency'>
                                        اپنے داخلے کی کیفیت منتخب کریں
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <select
                                        name='residency'
                                        defaultValue={educationInformation['residency']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    residency: e.target.value,
                                                    is_from_hostel_status_for_card:
                                                        e.target.value === 'اقامتی' ? true : false,
                                                });
                                            } else {
                                                setEducationInformation({
                                                    ...educationInformation,
                                                    residency: educationInformation['residency'],
                                                    is_from_hostel_status_for_card:
                                                        educationInformation[
                                                            'is_from_hostel_status_for_card'
                                                        ],
                                                });
                                            }
                                        }}
                                    >
                                        <option value='none'>داخلے کی کیفیت منتخب کریں</option>
                                        {hostilites.map((hosValue, index) => (
                                            <option value={hosValue} key={index + 1}>
                                                {hosValue}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div
                            className='flex justifyEnd alignCenter w-100'
                            style={{ height: 64, marginTop: 16 }}
                        >
                            <div className='flex justifyBetween alignCenter'>
                                <div
                                    className='flex justifyEnd alignCenter register_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onUpdate()}
                                >
                                    {loading ? (
                                        <div className='custom_loader' />
                                    ) : (
                                        <h3>{`محفوظ کریں`}</h3>
                                    )}
                                </div>
                                <div
                                    className='flex justifyEnd alignCenter delete_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onClose()}
                                >
                                    <h3>{`منسوخ کریں`}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EducationDetails;
